import { useField, useFormikContext } from 'formik'
import { useEffect, type FC } from 'react'
import { FormKeys, type SelectOption, type Values } from '../../SignUpForm.interface'
import FormSelect from './FormSelect'

interface BusinessSelectorProps {
  name: keyof Values;
  label?: string;
  optionalText?: string;
  categories: SelectOption[];
  placeholder?: string;
}

export const BusinessSelector: FC<BusinessSelectorProps> = ({ name, categories, ...props }) => {
  const [field] = useField<keyof Values>(name)

  const { setFieldValue } = useFormikContext()

  useEffect(() => {
    const cat = categories.find((category) => category.value === field.value)
    // setCategoryString(cat?.pluralisationText ?? '')
    void setFieldValue(FormKeys.PLURALISED_CATEGORY_NAME, cat?.pluralisationText ?? '')
  }, [field.value, categories, setFieldValue])

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormSelect name={name} options={categories} {...props} />
  )
}
